import * as moment from 'moment';

import { FormField } from '../forms/form-field.model';
import { User } from '../users/user.model';
import { DistributionList } from '../users/distribution-list.model';

export class Template {

  author: User;
  createdDate: number;
  data: any = {};
  dirty: boolean = false;
  distributionLists: DistributionList[] = [];
  groupId: number;
  id: number;
  isArchived: boolean = false;
  isFavorite: boolean = false;
  isPublic: boolean = false;
  isRecent: boolean = false;
  canModify: boolean = false;
  lockValues: boolean = false;
  name: string;
  recipients: User[] = [];
  submittedDate: number;
  submittedUser: User;
  updatedDate: number;
  workflowId: number;
  workflowName: string;

  get createdMoment(): moment.Moment {
    if (this.createdDate == null) {return null}
    return moment(this.createdDate);
  }

  get submittedMoment(): moment.Moment {
    if (this.submittedDate == null) {return null}
    return moment(this.submittedDate);
  }

  public constructor(init?:Partial<Template>) {
    Object.assign(this, init);
  }

  static fromRecord(record) {
    let template = new Template();
    template.author = User.fromRecord(record.author);
    template.createdDate = +record.date_created;
    template.updatedDate = +record.last_updated;
    template.groupId = +record.template_group_id;
    template.id = +record.template_id;
    template.isArchived = (record.is_archived === true);
    template.isPublic = (record.is_public === true);
    template.canModify = (record.can_modify === true);
    template.lockValues = (record.lock_supplied_values === true);
    template.name = record.template_name;
    template.submittedDate = record.date_submitted;
    template.submittedUser = record.user_submitted != null ? User.fromRecord(record.user_submitted) : null;
    template.workflowId = record.workflow.wf_id;
    template.workflowName = record.workflow.wf_name;
    template.distributionLists = record.distribution_lists.map((l) => DistributionList.fromRecord(l));
    template.recipients = record.recipients.map((r) => User.fromRecord(r));
    template.data = this.flattenData(record.template_data);
    return template;
  }

  static flattenData(data) {
    let templateData = {}
    if (data.hasOwnProperty("data")) {
      // Older style template data
      for (let field of data.data) {
        let id = (''+field.id).toLowerCase()
        if (field.values != null) {
          let values = field.values.filter((v) => {
            return v.stored != null && (''+v.stored).trim() !== '' &&
            v.displayed != null && (''+v.displayed).trim() !== ''
          })
          if (values.length > 0) {
            templateData[id] = values;
          }
        }
      }
    } else {
      for (let key in data) {
        let id = key.toLowerCase()
        let value = data[key];
        templateData[id] = value;
      }
    }
    return templateData;
  }

}


// WEBPACK FOOTER //
// ./src/app/templates/template.model.ts